export default __webpack_public_path__ + "static/riccardo_deckruede-553c23e76f5f853d1b763a2a0f15c96a.jpg";